import React from 'react';
import { useTranslation } from 'react-i18next';

import { Label } from '../../../../styles/sharedUIElemStyles';
import { debounce } from 'debounce';
import { TextArea } from './FormTextArea.style';
import { FormDataText } from '../../../../styles/sharedUIElemStyles';

interface Value {
  data: string;
  dataIndex: string;
}
export interface Props {
  index: string;
  updateFormData: (data: any) => void;
  value: Value;
  defaultValue: Value;
  readOnly: boolean;
  template: any;
}
/**
 * Komponent do wpisywania długiej wartości tekstowej
 *
 */
export const FormTextArea: React.FunctionComponent<Props> = (props: Props): React.ReactElement => {
  const { t } = useTranslation();

  const updateForm = debounce((value: string): void => {
    props.updateFormData({ ...props.value, data: value });
  }, 200);
  return (
    <>
      {props.readOnly ? (
        <FormDataText>{props.value.data && props.value.data.length ? props.value.data : t('NO_DATA')}</FormDataText>
      ) : (
        <>
          <p>
            {!props.readOnly ? (
              <Label>
                {t('BEFORE_CHANGE')}
                :&nbsp;
              </Label>
            ) : null}
            {props.defaultValue.data && props.defaultValue.data.length ? (
              <TextArea
                disabled={true}
                defaultValue={props.defaultValue.data}
                autoSize={{ minRows: props.defaultValue.data && props.defaultValue.data.length ? 4 : 2 }}
              />
            ) : (
              <FormDataText>{t('NO_DATA')}</FormDataText>
            )}
          </p>
          <TextArea
            allowClear
            defaultValue={props.defaultValue.data}
            onChange={({ currentTarget: { value } }: React.ChangeEvent<HTMLTextAreaElement>): void => updateForm(value)}
            autoSize={{ minRows: props.defaultValue.data && props.defaultValue.data.length ? 4 : 2 }}
          />
        </>
      )}
    </>
  );
};
export default FormTextArea;
